export enum DialogName {
  WinningAnimation = 'winning_animation',
  Confirmation = 'confirmation',
  PlatformLink = 'platform_link',
  UnlinkPlatform = 'unlink_platform',
  ActionGuard = 'action_guard',
}
